import User from './user';
import Profile from './profile';

class foodBenefitUser extends User{
  constructor(userId, profile) {
    super(userId, profile);
    this.cards = [];
    this.delegations = [];
  }

  hasManagerDelegation() {
    return this._profile.delegation.type === Profile.DELEGATION_MANAGER();
  }
}

export default foodBenefitUser;



// WEBPACK FOOTER //
// ./client/app/common/domain/models/foodBenefitUser.js